<template>
<!--     cache-items -->
  <v-autocomplete
    v-model="prodotto"
    :loading="loading"
    :items="items"
    :search-input.sync="searchProdotto"

    no-data-text="Cerca un prodotto per codice o descrizione (% cerca fulltext)"
    :label="item.label"
    :rules="rulesValidation"
    item-text="testo"
    item-value="id"
    clearable
    dense
    hide-details="auto"
    :solo="suTable"
    :flat="suTable"
    :outlined="!suTable"
    :background-color="backColor"
    :return-object="true"
    :disabled="disabled"
    @change="onchange"
    @keydown="onKeyDown"
    @click:clear="clear"
    v-if="showItem"
  >
    <template v-slot:prepend>
      <v-icon v-if="item.cercaEsterno" @click="onCercaEsterno" title="Cerca il prodotto in un archivio esterno" :disabled="searchDisabled">mdi-folder-search-outline</v-icon>
      <ricerca-esterna :openSearch="openSearch" @importaEsterno="onImportaEsterno"/>
    </template>
    <template v-slot:[`selection`]="{ item }">
      {{ item.codice }}
    </template>
    <template v-slot:[`item`]="{ item }">
      {{ item.testo }}
    </template>    
    <template v-slot:append-outer>
      <v-icon v-if="!item.addForbidden" color="success" @click="onNuovoArticolo" title="Crea un nuovo prodotto">mdi-archive-plus-outline</v-icon>
    </template>
  </v-autocomplete>
</template>

<script>
  import _ from 'lodash'
  import { validazioni } from '@/mixins/validazioni.js'
  import { sanitize } from '@/helpers/sanitize'
  import prodotti from '@/services/prodottiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import RicercaEsterna from '@/views/documenti/components/edit/elementi/ricercaEsterna'

  export default {
    name: 'prodotto',
    components: {
      RicercaEsterna
    },
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,
      disabled: { type: Boolean, default: false },
      updateTrigger: Number,
      index: Number,
      suTable: { type: Boolean, default: false },
      refreshSource: Number,
      refreshSourceCode: String,
      forzaAggiornamento: { type: Boolean, default: false },
      abilitaRicercaInterna: { type: Boolean, default: false },
      backColor: { type: String, default: 'transparent' }
    },
    data (vm) {
      return {
        loading: false,
        items: [],
        debounceSearch: null,
        searchProdotto: '',
        prodotto: '',
        bloccaWatch: false,
        newItem: null,
        openSearch: false,
        initRefresh: false,
        prependMarchio: false,
        isBarcode: false
      }
    },
    async created() {
      this.debounceSearch = _.debounce(this.searchProdottoDeb, 500)
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.prependMarchio = _.get(impostazioni, 'prodotti.prependMarchio', false)
    },
    async mounted() {
      this.initRefresh = true
      await this.refresh()
      this.initRefresh = false
    },
    watch: {
      async searchProdotto(val) {
        if (this.bloccaWatch) {
          this.bloccaWatch = false
          return
        }
        await this.debounceSearch(val)
      },
      prodottiSelezionati() {
        this.searchProdotto = ''
      },
      updateTrigger() {
        this.$forceUpdate()
      },
      async refreshSource() {
        if (this.refreshSourceCode === this.item.value) {
          await this.refresh()
        }
      },
      async forzaAggiornamento(value) {
        if (value) {
          await this.refresh()
        }
      }    
    },
    computed: {
      showItem() {
        if (this.item && this.item.showIf) {
          return _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      },
      searchDisabled() {
        return this.prodotto ? true : false
      }      
    },    
    methods: {
      onKeyDown(ev) {
        if (ev.key === 'Enter') {
          this.isBarcode = true
        }
      },      
      async refresh() {
        if (this.item && this.item.value) {
          await this.querySelections(this.item.value)
          this.bloccaWatch = true
          this.prodotto = Object.assign({}, this.items[0])
          this.onchange(this.prodotto)
        }
      },
      async onImportaEsterno({ nuoviArticoli, esistenti }) {
        const modello = await prodotti.getModello()
        const impostazioni = await configurazioni.getConfigurazione('file_esterni', 'impostazioni')
        for (let v of nuoviArticoli) {
          let newP = JSON.parse(JSON.stringify(modello))
          newP._id = sanitize(v._id)
          newP.marchio = v.marchio.codice, // TODO: Verificare. Su TUTTO dovrebbe essere riportato Codice e Descrizione
          newP.produttore = v.marchio
          newP.descrizione = v.DescrizioneProdotto
          newP.custom = {
            esterno: true,
            siglaMarchio: v.SiglaMarchio,
            anno: v.anno
          }
          newP.codice = sanitize(v.CodiceProdottoProduttore)
          newP.datiFiscali = impostazioni.default.datiFiscali
          if (String(v.CodiceEAN).length > 7) {
            newP.barcode.push({
              codice: v.CodiceEAN,
              da: new Date(),
              attivo: true,
              importOn: `esterni: ${v.filename}`
            })
          }
          newP.prezzo[impostazioni.default.listino] = { base: v.PrezzoAlPubblico } // MoltiplicatorePrezzo ??
          let um = v.UnitaDiMisura.toLowerCase()
          if (['pce', 'pcs', 'pezzi', 'pieces'].includes(um)) {
            um = 'pz'
          }
          if (['ml', 'lm', 'metri'].includes(um)) {
            um = 'm'
          }             
          _.set(newP, 'magazzino.unitaMisura', um)
          _.set(newP, 'magazzino.minimoOrdinabile', v.QuantitaMinimaOrdinazione)
          _.set(newP, 'magazzino.leadTime', parseInt(v.LeadTime || 0))
          _.set(newP, 'magazzino.quantitaMultiplaOrdinazione', v.QuantitaMultiplaOrdinazione)
          _.set(newP, 'magazzino.quantitaMassimaOrdinazione', v.QuantitaMassimaOrdinazione)
          _.set(newP, 'magazzino.quantitaCartone', v.QuantitaCartone)
          _.set(newP, 'statistici.categoria1', v.Categoria)
          try {
            const creato = await prodotti.creaProdotto(newP)
            await this.querySelections(newP.codice)
            this.prodotto = Object.assign({}, this.items[0])
            await this.$nextTick()
            this.$forceUpdate()
            this.onchange(this.prodotto)
          } catch(err) {
            console.log('errore creazione', err)
          }
        }
        for (let v of esistenti) {
          await this.querySelections(v.codice)
          this.prodotto = Object.assign({}, this.items[0])
          let daAggiornare = this.prodotto.item

          daAggiornare.prezzo[impostazioni.default.listino] = { base: v.PrezzoAlPubblico }
          await prodotti.aggiornaProdotto(daAggiornare)
          await this.$nextTick()
          this.$forceUpdate()
          this.onchange(this.prodotto)    
        }
        await prodotti.clearCache()
      },
      getDescrizione(item) {
        return `${item.codice} - ${item.descrizione} ${_.get(item, 'variante2.descrizione', '')} ${_.get(item, 'variante1.descrizione', '')}`
      },
      async searchProdottoDeb(val) {
        // TODO: verificare se quello cercato è già presente prima di richiamare
        // const pr = this.prodottiSelezionati.filter(x => x === val)
        // if (val && pr.length === 0) {
        if (val) {
          await this.querySelections(val)
        }
      },
      async querySelections (val) {
        if (val === '%') {
          this.items = []
          return
        }
        this.loading = true
        var cp, testo
        let prefisso = ''
        // console.log('usaScalaTaglie', this.item.usaScalaTaglie)
        // console.log('initRefresh', this.initRefresh)
        if (this.isBarcode) {
          // TODO: Da sistemare. In questo modo funziona solo se leggo il barcode con il lettore.
          //       Se lo digito non prende l'enter in coda e non imposta isBarcode
          //       Nella ricerca trova il prodotto, ma non mette il valore del barcode nella descrizione da visualizzare ("testo")
          //       e quindi l'autocomplete non lo visualizza. Al limite visualizzare sempre il barcode se presente nell'archivio 
          const data = await prodotti.getInfoFromBarcode(val)
          cp = [data]
        } else if (this.abilitaRicercaInterna && !val.startsWith('%') && !this.initRefresh) {
          const data = await prodotti.searchProdottiPost(val, false, 1000, {}) // New
          cp = data && data.docs.length > 0 ? data.docs : []
        } else {        
          testo = val && val.startsWith('%') ? val.substring(1).trim() : val
          let filtri = {
/*             id: testo,
            codice: testo */
          }
          prefisso = ''
          if (val && val.startsWith('%')) {
            filtri.testo = testo
            prefisso = '%'
          } else {
            filtri.id = testo
            filtri.codice = testo    

            filtri.descrizione = testo
            filtri.barcode = testo // verificare
          }
          const opzioni =  {
            itemsPerPage: 50
          }
          const data = await prodotti.getFilteredProducts(filtri, opzioni)
          cp = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
        }
        if (this.item.usaScalaTaglie) {
          cp = cp.filter(x => x.custom && x.custom.scalaTaglie && x.custom.scalaTaglie.prodottoMaster)
        } else {
          cp = cp.filter(x => !(x.custom && x.custom.scalaTaglie && x.custom.scalaTaglie.prodottoMaster))
        }
        this.items = _.uniqBy(cp, 'ricercaTC').map(x => {
          const v1 = _.get(x, 'varianti.variante1', {})
          const v2 = _.get(x, 'varianti.variante2', {})
          let descPrefisso = x.descrizione
          if (prefisso) {
            const idx = x.descrizione.toLowerCase().indexOf(testo.toLowerCase())
            const len = testo.length
            if (idx !== -1) {
              descPrefisso = x.descrizione.substring(0, idx) + val + x.descrizione.substring(idx + len)
            }
          }
          if (this.item.usaScalaTaglie) {
            return { 
              testo: (`${this.prependMarchio ? (x.marchio || '') + ': ' : ''}${x.codice} - ${descPrefisso} ${ this.isBarcode ? '-' + x.ricercaBarcode : ''}`).trim(),
              id: x.codice, // x._id,
              codice: x.codice,
              descrizione: (`${x.descrizione}`).trim(),
              prezzo: x.prezzo && x.prezzo.L1 && x.prezzo.L1.base, // TODO: Prendere listino di default da configurazione (su store..)
              prezzo2: x.prezzo && x.prezzo.L2 && x.prezzo.L2.base,
              prezzoItem: x.prezzo,
              acquisto: x.magazzino && x.magazzino.prezzoAcquisto,
              variante1: v1,
              variante2: v2,
              datiFiscali: x.datiFiscali || {},
              item: x
            }
          } else {  
            return { 
              // testo: `${this.prependMarchio ? (x.marchio || '') + ': ' : ''}${x.codice} - ${descPrefisso} ${_.get(x, 'varianti.variante2.descrizione', '')} ${_.get(x, 'varianti.variante1.descrizione', '')}`,
              testo: (`${this.prependMarchio ? (x.marchio || '') + ': ' : ''}${x.codice} - ${descPrefisso} ${_.get(x, 'varianti.variante2.descrizione', '')} ${_.get(x, 'varianti.variante1.descrizione', '')} ${ this.isBarcode ? '-' + x.ricercaBarcode : ''}`).trim(),
              testoShort: `${x.codice} - ${x.descPrefisso} ${_.get(x, 'varianti.variante2.descrizione', '')} ${_.get(x, 'varianti.variante1.descrizione', '')}`,
              id: x._id,
              codice: x.codice,
              // descrizione: `${x.descrizione} ${_.get(x, 'varianti.variante2.descrizione', '')} ${_.get(x, 'varianti.variante1.descrizione', '')}`,
              descrizione: (`${x.descrizione} ${_.get(x, 'varianti.variante2.descrizione', '')} ${_.get(x, 'varianti.variante1.descrizione', '')}`).trim(),
              prezzo: x.prezzo && x.prezzo.L1 && x.prezzo.L1.base, // TODO: Prendere listino di default da configurazione (su store..)
              prezzo2: x.prezzo && x.prezzo.L2 && x.prezzo.L2.base,
              prezzoItem: x.prezzo,
              acquisto: x.magazzino && x.magazzino.prezzoAcquisto,
              variante1: v1,
              variante2: v2,
              datiFiscali: x.datiFiscali || {},
              item: x
            }
          }
        })
        // console.log(this.items)
        this.isBarcode = false
        this.loading = false
      },
      clear() {
        this.searchProdotto = ''
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: '', item: null, index: this.index })   
      },      
      onchange(value) {
        if (value) {
          this.searchProdotto = ''
          // this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: this.item.value.id, item: this.item.value })
          this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: this.prodotto.id, item: value, index: this.index })          
        }
      },
      async onNuovoArticolo() {
        this.$emit('nuovoArticolo', this.index)
/*         const defaultItem = await prodotti.getModello()
        this.$store.commit('prodotti/SET_PRODOTTO', JSON.parse(JSON.stringify(defaultItem))) */
/*         this.newItem = await prodotti.getModello()
        this.$store.commit('prodotti/SET_PRODOTTO', this.newItem)
        
        this.$store.commit('movimenti/SET_CREA_ARTICOLO') */
      },
      async onCercaEsterno() {
        this.openSearch = true
        await this.$nextTick()
        this.openSearch = false
      }       
    }
  }
  // https://stackoverflow.com/questions/46967557/how-do-i-change-font-size-in-vuetify-component
</script>
